<template>
  <div class="page page-user-edit">
    <van-notice-bar
      color="#1989fa"
      background="#ecf9ff"
      wrapable
      :scrollable="false"
      left-icon="info-o"
    >
      入职信息一经提交不可修改，请仔细填写。若不能确认部分信息可先使用保存功能！
    </van-notice-bar>
    <van-form ref="formData">
      <van-cell-group class="app-card">
        <van-field
          class="readonly"
          label-align="left"
          v-model="userInfo.name"
          label="姓名"
          placeholder="未录入"
          :readonly="true"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <van-field
          class="readonly"
          v-model="userInfo.idCard"
          :readonly="true"
          label="身份证号码"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <van-field
          name="radio"
          label="证件有效期类型"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <template #input>
            <van-radio-group
              v-model="userInfo.idCardEndType"
              direction="horizontal"
            >
              <van-radio name="固定">固定</van-radio>
              <van-radio v-if="isAgeGreaterThan45" name="长期">长期</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <template>
          <date-field
            v-model="userInfo.idCardStart"
            label="证件有效期起"
            :min-date="minIdCardDate"
            :required="true"
          ></date-field>
        </template>
        <template v-if="userInfo.idCardEndType === '固定'">
          <date-field
            v-model="userInfo.idCardEnd"
            label="证件有效期至"
            :min-date="minIdCardDateEnd"
            :max-date="maxIdCardDateEnd"
            :required="true"
            :placeholder="
              userInfo.idCardStart ? '未选择' : '请先选择证件起始有效期'
            "
            :disabled="!userInfo.idCardStart"
          ></date-field>
        </template>
        <van-cell title="身份证拍照[人像面]">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传身份证[人像面]')"
              >身份证拍照[人像面]</span
            >
          </template>
          <upload
            v-model="userInfo.docIdCard"
            :multiple="false"
            :params="uploadParams"
            type="idFront"
          ></upload>
        </van-cell>
        <van-cell title="身份证拍照[国徽面]">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传身份证[国徽面]')"
              >身份证拍照[国徽面]</span
            >
          </template>
          <upload
            v-model="userInfo.docIdCardBack"
            :multiple="false"
            :params="uploadParams"
            type="idBack"
          ></upload>
        </van-cell>
        <van-cell title="户口本拍照[首页]">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传户口本拍照[首页]')"
              >户口本拍照[首页]</span
            >
          </template>
          <upload
            v-model="userInfo.hukoubenHome"
            :multiple="false"
            :params="uploadParams"
            type="default"
          ></upload>
        </van-cell>
        <van-cell title="户口本拍照[本人页]">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传户口本拍照[本人页]')"
              >户口本拍照[本人页]</span
            >
          </template>
          <upload
            v-model="userInfo.hukoubenSelf"
            :multiple="false"
            :params="uploadParams"
            type="default"
          ></upload>
        </van-cell>

        <van-field
          class="readonly"
          v-model="userInfo.companyName"
          :readonly="true"
          label="入职单位"
          placeholder="未录入"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <sys-dict
          v-model="userInfo.gender"
          dict-name="gender"
          label="性别"
          :readonly="!!sourceInfo.gender"
          :class="{ readonly: !!sourceInfo.gender }"
          required
        />
        <sys-dict
          v-model="userInfo.xueliType"
          dict-name="xueliType"
          label="学历"
          required
        />
        <sys-dict
          v-if="false"
          v-model="userInfo.xueliTypeMax"
          dict-name="xueliTypeMax"
          label="最高学历"
          required
        />
        <sys-dict
          v-model="userInfo.zhicheng"
          dict-name="zhicheng"
          label="职称"
          required
        />
        <van-field
          v-model="userInfo.zhichengCate"
          v-if="userInfo.zhicheng && userInfo.zhicheng !== '无'"
          clearable
          label="申报职称专业"
          placeholder="请填写申报职称专业"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <sys-dict
          v-model="userInfo.nation"
          dict-name="nation"
          label="民族"
          required
        />
        <sys-dict
          v-model="userInfo.zhengzhiType"
          dict-name="zhengzhiType"
          label="政治面貌"
          required
        />
        <van-field
          v-model="userInfo.biyeSchoolName"
          label="毕业学校"
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <date-field
          v-model="userInfo.biyeSchoolEnd"
          label="毕业时间"
          :min-date="minWorkDate"
          :max-date="maxWorkDate"
          required
        />
        <van-field
          v-model="userInfo.biyeSchoolZhuanye"
          label="所学专业"
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <sys-dict
          v-model="userInfo.paiqianRyType"
          dict-name="paiqianRyType"
          label="是否应届"
          required
        />
        <van-cell
          v-if="userInfo.paiqianRyType !== '应届'"
          title="  离职证明上传"
        >
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传离职证明上传')"
              >离职证明上传</span
            >
          </template>
          <upload
            v-model="userInfo.docLeaveCert"
            :multiple="false"
            :params="uploadParams"
            type="default"
          ></upload>
        </van-cell>
        <date-field
          v-model="userInfo.canjiaWorkAt"
          label="参加工作时间"
          :min-date="minWorkDate"
          :max-date="maxWorkDate"
          required
        />
        <!--        <van-field name="radio" label="是否有残疾证" :readonly="!!sourceInfo.isCanji"-->
        <!--                   :class="{ readonly: !!sourceInfo.isCanji }" :rules="[{ required: true, message: '请选择' }]">-->
        <!--          <template #input>-->
        <!--            <van-radio-group v-model="userInfo.isCanji" :disabled="!!sourceInfo.isCanji"-->
        <!--                             direction="horizontal">-->
        <!--              <van-radio name="是">是</van-radio>-->
        <!--              <van-radio name="否">否</van-radio>-->
        <!--            </van-radio-group>-->
        <!--          </template>-->
        <!--        </van-field>-->
        <sys-dict
          v-model="userInfo.isCanji"
          dict-name="isCanji"
          label="是否有残疾证"
          required
        />
        <van-field
            v-if="userInfo.isCanji && userInfo.isCanji !== '无' && userInfo.isCanji !== '否'"
          v-model="userInfo.canjiCard"
          label="残疾证号"
          placeholder="请输入残疾证号"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <van-field
          v-if="false"
          v-model="userInfo.juzhuCard"
          label="北京居住证号"
          placeholder="若无可不填写"
        />
        <van-field
          value="北京工商银行"
          class="readonly label-offset"
          @click-left-icon="showHelp('必须为北京工商银行')"
          left-icon="question"
          :readonly="true"
          label="开户银行"
        />
        <van-field
          ref="eleInput"
          v-model="userInfo.gongziBankCardNo"
          @blur="onBankCardBlur"
          label="工资卡号"
          type="digit"
          maxlength="19"
          placeholder="请输入"
          @click-left-icon="showHelp(bankCardTip)"
          left-icon="question"
          :readonly="!!sourceInfo.gongziBankCardNo"
          :class="{
            readonly: sourceInfo.gongziBankCardNo,
            'label-offset': true,
          }"
          clearable
          :rules="[{ required: true, message: '请填写' }]"
        />
        <sys-dict
          v-if="false"
          v-model="userInfo.danganAddressType"
          dict-name="danganAddressType"
          label="档案存放地"
          required
        />
        <van-cell title="一寸证件照" style="color: #999">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              @click="
                showHelp(
                  '近期免冠1寸白底彩色照片，电子照片要求格式为jpg格式，电子文件不小于9KB，不大于500KB。建议用QQ或者邮箱将照片保存至手机再上传。'
                )
              "
            >
              一寸证件照
            </span>
          </template>
          <div class="van-uploader">
            <div class="van-uploader__wrapper">
              <template v-if="userInfo.certImgUrl">
                <div class="van-uploader__preview">
                  <div
                    class="van-image van-uploader__preview-image"
                    style="overflow: hidden; border-radius: 4px"
                  >
                    <img
                      :src="userInfo.certImgUrl"
                      class="van-image__img"
                      style="object-fit: cover"
                    />
                  </div>
                  <i
                    v-if="!sourceInfo.certImgUrl"
                    @click="userInfo.certImgUrl = null"
                    class="van-icon van-icon-clear van-uploader__preview-delete"
                    ><!----></i
                  >
                </div>
              </template>
              <div v-else @click="handlePickFile" class="van-uploader__upload">
                <i class="van-icon van-icon-plus van-uploader__upload-icon"
                  ><!----></i
                >
                <div class="van-uploader__input"></div>
              </div>
            </div>
          </div>
        </van-cell>
        <van-field
          v-model="userInfo.email"
          label="电子邮箱"
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写' }]"
        />
      </van-cell-group>
      <van-cell-group class="app-card">
        <div class="group-title">地址信息</div>
        <sys-dict
          v-model="userInfo.hukouProvince"
          dict-name="province"
          label="户口省份"
          @changeObject="handleChangeProvice"
          required
        />
        <van-field
          v-model="userInfo.hukouAddress"
          label="户口地址（户口本详细地址）"
          rows="2"
          placeholder="请输入"
          autosize
          type="textarea"
          :rules="[{ required: true, message: '请填写' }]"
          @click="showToast"
        />
        <van-field
          v-model="userInfo.contactAddress"
          label="通讯地址（现居住地址）"
          rows="2"
          placeholder="请输入通讯地址"
          autosize
          type="textarea"
          :rules="[
            {
              required: true,
              validator: checkContactAddress,
              message: '请按要求正确填写通讯地址',
            },
          ]"
          @click-left-icon="
            showHelp(
              '只能填写京津冀的通讯地址，地址里必须包含北京市、天津市和河北省三个当中的其中一个'
            )
          "
          @click="showToast"
          left-icon="question"
        />
        <sys-dict
          v-model="userInfo.houseAttr"
          dict-name="zhufangType"
          label="住房属性"
          required
        />
        <van-field
          v-if="false"
          v-model="userInfo.docAddress"
          label="文书送达地址"
          rows="2"
          placeholder="请输入文书送达地址"
          autosize
          type="textarea"
          :rules="[{ required: true, message: '请填写' }]"
          @click="showToast"
        />
      </van-cell-group>
      <van-cell-group class="app-card">
        <div class="group-title">紧急联系人</div>
        <van-field
          v-model="userInfo.emergency1"
          label="联系人姓名"
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <sys-dict
          v-model="userInfo.emergency1Relation"
          dict-name="emergency1Relation"
          label="与本人关系"
          required
        />
        <van-field
          v-model="userInfo.emergency1Mobile"
          label="联系人电话"
          type="digit"
          placeholder="请输入"
          maxlength="11"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <van-field
          v-model="userInfo.emergency1Address"
          label="联系人地址"
          rows="2"
          placeholder="请输入联系人地址"
          autosize
          type="textarea"
          :rules="[{ required: true, message: '请填写' }]"
        />
      </van-cell-group>
      <div class="app-card">
        <div class="group-title" style="border: none">社保信息</div>
        <sys-dict
          v-model="userInfo.hukouType"
          dict-name="hukouType"
          label="户口性质"
          required
        />
        <sys-dict
          v-model="userInfo.canbaoType"
          dict-name="canbaoType"
          left-icon="question"
          label="参保类型"
          showHelpIcon
          @clickLabel="showHelp('入职前未在北京地区参加社保请选择 新参统')"
          required
        />
        <sys-dict
          v-model="userInfo.isHasShebaoCard"
          dict-name="yesNo"
          label="是否有北京社保卡"
          required
        />
        <sys-dict
          v-model="userInfo.isHasGongjijin"
          dict-name="yesNo"
          label="是否有北京住房公积金"
          required
        />
        <!--      <van-field-->
        <!--          v-model="userInfo.shebaoHospital1"-->
        <!--          label="定点医疗机构1"-->
        <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital1"-->
        <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital1 }"-->
        <!--      />-->
        <!--      <van-field-->
        <!--          v-model="userInfo.shebaoHospital2"-->
        <!--          label="定点医疗机构2"-->
        <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital2"-->
        <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital2 }"-->
        <!--      />-->
        <!--      <van-field-->
        <!--          v-model="userInfo.shebaoHospital3"-->
        <!--          label="定点医疗机构3"-->
        <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital3"-->
        <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital3 }"-->
        <!--      />-->
        <!--      <van-field-->
        <!--          v-model="userInfo.shebaoHospital4"-->
        <!--          label="定点医疗机构4"-->
        <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital4"-->
        <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital4 }"-->
        <!--      />-->
        <!--      <van-field-->
        <!--          v-model="userInfo.shebaoHospital5"-->
        <!--          v-if="userInfo.shebaoHospital5"-->
        <!--          label="定点医疗机构5"-->
        <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital5"-->
        <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital5 }"-->
        <!--      />-->
      </div>

      <div class="app-card">
        <div class="group-title">原工作单位信息</div>
        <div class="van-cell ck-wrapper">
          <span class="van-field__label">入职前未参加工作</span>
          <van-checkbox
            v-model="preHasNoWork"
            @change="handlePreHasWorkChange"
          ></van-checkbox>
        </div>
        <van-cell-group v-if="!preHasNoWork">
          <van-field
            v-model="userInfo.preCompanyName"
            label="原单位名称"
            placeholder="请输入"
            :rules="[{ required: true, message: '请填写' }]"
          />
          <date-field
            v-model="userInfo.preContract"
            label="合同截止日期"
            :min-date="minPreWorkDate"
            :max-date="maxPreWorkDate"
            required
          />
          <van-field
            v-model="userInfo.preShebaoLocate"
            label="原社保地区"
            placeholder="请输入"
            :rules="[{ required: true, message: '请填写' }]"
          />
          <date-field
            v-model="userInfo.preShebaoAt"
            label="原社保缴纳至"
            :min-date="minPreWorkDate"
            :max-date="maxPreWorkDate"
            required
          />
        </van-cell-group>
      </div>

      <van-cell-group class="app-card">
        <div class="group-title">其它信息</div>
        <van-field name="radio" label="是否被追究过刑事责任">
          <template #input>
            <van-radio-group
              v-model="userInfo.isCriminal"
              direction="horizontal"
              :rules="[{ required: true, message: '请选择' }]"
            >
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="是否被列为失信被执行">
          <template #input>
            <van-radio-group
              v-model="userInfo.isDishonest"
              direction="horizontal"
              :rules="[{ required: true, message: '请选择' }]"
            >
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="是否因严重违纪被辞退">
          <template #input>
            <van-radio-group
              v-model="userInfo.isDismissed"
              direction="horizontal"
              :rules="[{ required: true, message: '请选择' }]"
            >
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="是否与单位发生纠纷">
          <template #input>
            <van-radio-group
              v-model="userInfo.isDispute"
              direction="horizontal"
              :rules="[{ required: true, message: '请选择' }]"
            >
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="是否从事有毒有害工种">
          <template #input>
            <van-radio-group
              v-model="userInfo.isHazardous"
              direction="horizontal"
              :rules="[{ required: true, message: '请选择' }]"
            >
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="是否曾被认定为工伤">
          <template #input>
            <van-radio-group
              v-model="userInfo.isInjured"
              direction="horizontal"
              :rules="[{ required: true, message: '请选择' }]"
            >
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group class="app-card">
        <div class="group-title">家庭成员信息1</div>
        <van-field
          v-model="userInfo.familyName1"
          label="家庭成员姓名1"
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <sys-dict
          v-model="userInfo.familyRelation1"
          dict-name="familyRelation"
          label="家庭成员关系1"
          required
        ></sys-dict>
        <van-field
          v-model="userInfo.familyWork1"
          label="家庭成员工作单位1"
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <van-field
          v-model="userInfo.familyMobile1"
          label="家庭成员联系电话1"
          type="digit"
          placeholder="请输入"
          maxlength="11"
          :rules="[{ required: true, message: '请填写' }]"
        />
      </van-cell-group>

      <van-button
        class="family-btn"
        v-if="!showFamily2"
        icon="plus"
        type="primary"
        @click="showFamily2 = true"
        native-type="button"
      >
        增加家庭成员
      </van-button>

      <van-cell-group class="app-card" v-if="showFamily2">
        <div class="group-title">
          家庭成员信息2
          <van-button
            v-if="!showFamily3"
            style="float: right"
            type="danger"
            size="mini"
            @click="removeFamily2"
            native-type="button"
            >删除
          </van-button>
        </div>
        <van-field
          v-model="userInfo.familyName2"
          label="家庭成员姓名2"
          placeholder="请输入"
        />
        <sys-dict
          v-model="userInfo.familyRelation2"
          dict-name="familyRelation"
          label="家庭成员关系2"
        ></sys-dict>
        <van-field
          v-model="userInfo.familyWork2"
          label="家庭成员工作单位2"
          placeholder="请输入"
        />
        <van-field
          v-model="userInfo.familyMobile2"
          label="家庭成员联系电话2"
          type="digit"
          placeholder="请输入"
          maxlength="11"
        />
      </van-cell-group>

      <van-button
        class="family-btn"
        v-if="!showFamily3 && showFamily2"
        icon="plus"
        type="primary"
        native-type="button"
        @click="showFamily3 = true"
        >增加家庭成员
      </van-button>

      <van-cell-group class="app-card" v-if="showFamily3">
        <div class="group-title">
          家庭成员信息3
          <van-button
            v-if="!showFamily4"
            style="float: right"
            type="danger"
            size="mini"
            @click="removeFamily3"
            native-type="button"
            >删除
          </van-button>
        </div>
        <van-field
          v-model="userInfo.familyName3"
          label="家庭成员姓名3"
          placeholder="请输入"
        />
        <sys-dict
          v-model="userInfo.familyRelation3"
          dict-name="familyRelation"
          label="家庭成员关系3"
        ></sys-dict>
        <van-field
          v-model="userInfo.familyWork3"
          label="家庭成员工作单位3"
          placeholder="请输入"
        />
        <van-field
          v-model="userInfo.familyMobile3"
          label="家庭成员联系电话3"
          type="digit"
          placeholder="请输入"
          maxlength="11"
        />
      </van-cell-group>

      <van-button
        class="family-btn"
        v-if="!showFamily4 && showFamily3"
        icon="plus"
        type="primary"
        native-type="button"
        @click="showFamily4 = true"
        >增加家庭成员
      </van-button>

      <van-cell-group class="app-card" v-if="showFamily4">
        <div class="group-title">
          家庭成员信息4
          <van-button
            style="float: right"
            type="danger"
            size="mini"
            @click="removeFamily4"
            native-type="button"
            >删除
          </van-button>
        </div>
        <van-field
          v-model="userInfo.familyName4"
          label="家庭成员姓名4"
          placeholder="请输入"
        />
        <sys-dict
          v-model="userInfo.familyRelation4"
          dict-name="familyRelation"
          label="家庭成员关系4"
        ></sys-dict>
        <van-field
          v-model="userInfo.familyWork4"
          label="家庭成员工作单位4"
          placeholder="请输入"
        />
        <van-field
          v-model="userInfo.familyMobile4"
          label="家庭成员联系电话4"
          type="digit"
          placeholder="请输入"
          maxlength="11"
        />
      </van-cell-group>

      <van-button
        class="family-btn"
        v-if="!showFamily5 && showFamily4"
        icon="plus"
        type="primary"
        native-type="button"
        @click="showFamily5 = true"
        >增加家庭成员
      </van-button>

      <van-cell-group class="app-card" v-if="showFamily5">
        <div class="group-title">
          家庭成员信息5
          <van-button
            style="float: right"
            type="danger"
            size="mini"
            @click="removeFamily5"
            native-type="button"
            >删除
          </van-button>
        </div>
        <van-field
          v-model="userInfo.familyName5"
          label="家庭成员姓名5"
          placeholder="请输入"
        />
        <sys-dict
          v-model="userInfo.familyRelation5"
          dict-name="familyRelation"
          label="家庭成员关系5"
        ></sys-dict>
        <van-field
          v-model="userInfo.familyWork5"
          label="家庭成员工作单位5"
          placeholder="请输入"
        />
        <van-field
          v-model="userInfo.familyMobile5"
          label="家庭成员联系电话5"
          type="digit"
          placeholder="请输入"
          maxlength="11"
        />
      </van-cell-group>

      <div class="app-card">
        <van-field
          v-if="false"
          v-model="userInfo.submitRemark"
          label="备注信息"
          rows="4"
          placeholder="请输入"
          autosize
          type="textarea"
        />
      </div>
      <div style="margin-bottom: 60px; height: 1px; width: 100%"></div>
      <div
        class="fixed-bottom"
        style="
          background: #fff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-around;
        "
      >
        <template v-if="userInfo.auditStatus === '待审核'">
          <van-button style="width: 40%" plain type="info" round>
            审核中
          </van-button>
        </template>
        <template
          v-if="
            !userInfo.auditStatus ||
            userInfo.auditStatus === '未提交' ||
            userInfo.auditStatus === '审核未通过'
          "
        >
          <van-button
            style="width: 40%"
            plain
            type="info"
            round
            native-type="button"
            @click="handleClickSave"
            >保存
          </van-button>
          <van-button style="width: 40%" type="info" round @click="checkSubmit"
            >确认并提交</van-button
          >
        </template>
      </div>
      <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
      <!-- <van-number-keyboard :show="showBankCard" v-model="userInfo.gongziBankCardNo" maxlength="19" close-button-text="确定" @close="handleConfirmBankCard(1)" :title="userInfo.gongziBankCardNo || bankCardTip" @blur="handleConfirmBankCard(2)"/> -->
      <van-dialog
        v-model="showBankCardConfirm"
        title="工资卡号确认"
        @confirm="handleBankCardConfirm"
      >
        <van-field
          ref="eleConfirm"
          v-model="inputBankCard"
          input-align="center"
          placeholder="在这里再次输入工资卡号"
          type="digit"
          maxlength="19"
          size="large"
        />
      </van-dialog>
    </van-form>
  </div>
</template>

<style>
.label-offset .van-field__label {
  width: 95px;
}

.van-icon-question::before {
  color: #999;
  font-size: 16px;
}

.van-field__left-icon {
  margin-right: 0;
}

.van-field__control {
  color: #000000;
}

.van-field__label {
  color: #1989fa;
}

.van-field__label {
  width: 110px;
}

/* 	.readonly input {
		color: #999;
	} */
.readonly .van-cell__title,
.readonly .van-field__control {
  color: #999;
}

.van-field__label {
  text-align: left;
}

.ck-wrapper .van-field__label {
  width: 210px;
}

.van-uploader__preview,
.van-uploader__upload {
  margin-top: 8px;
}

.van-uploader__preview-image {
  border: 1px solid #eee;
}

.family-btn {
  width: calc(100% - 24px);
  margin: 0 12px;
}
</style>

<script>
import BindPersonnel from "@/components/BindPersonnel";
import mixinLoad from "@/mixin/mixin-load.js";
import SysDict from "@/components/SysDict";
import DateField from "@/components/DateField";
import { NumberKeyboard } from "vant";

import nativeApi from "@/utils/native-bridge.js";

import { formatDate, toDate } from "@/utils/util.js";
import { getDetail, saveDetail, submitDetail } from "@/api/user.js";

import { uploadCert } from "@/api/upload.js";

import { notifyContent } from "@/utils/sys-dict.js";
import Upload from "@/components/Upload";

const fullYear = new Date().getFullYear();
const oneMonthTime = 24 * 3600 * 1000 * 31;

const minWorkDate = new Date();
minWorkDate.setFullYear(fullYear - 70);

const maxWorkDate = new Date();
maxWorkDate.setTime(maxWorkDate.getTime() + oneMonthTime * 3);

const birthDayMin = new Date();
birthDayMin.setFullYear(fullYear - 70);

const birthDayMax = new Date();
birthDayMax.setFullYear(fullYear - 17);

const minPreWorkDate = new Date();
minPreWorkDate.setFullYear(minPreWorkDate.getFullYear() - 10);

const maxPreWorkDate = new Date();
maxPreWorkDate.setTime(maxPreWorkDate.getTime() + oneMonthTime);

const minIdCardDate = new Date();
minIdCardDate.setFullYear(2004);
minIdCardDate.setMonth(0);
minIdCardDate.setDate(1);

export default {
  name: "UserInfo",
  components: {
    Upload,
    SysDict,
    DateField,
    BindPersonnel,
    [NumberKeyboard.name]: NumberKeyboard,
  },
  mixins: [mixinLoad],
  data() {
    return {
      uploadParams: {
        fileType: "img",
        subType: "png,jpeg,jpg",
        fileMaxSize: "10240",
        checkFile: "0",
        serverCheck: "1",
        secrecyLevel: "1",
      },
      bankCardTip: "本人在京19位工商银行储蓄卡号",
      showBankCardConfirm: false,
      inputBankCard: null,
      inputBankCard1: null,
      showBankCard: false,
      helpTip: null,
      fileList: [],
      minWorkDate: minWorkDate,
      maxWorkDate: maxWorkDate,
      minPreWorkDate: minPreWorkDate,
      maxPreWorkDate: maxPreWorkDate,
      minIdCardDate: minIdCardDate,
      nowDate: new Date(),
      preHasNoWork: false,
      sourceInfo: {},
      userInfo: {
        canbaoType: undefined,
        certImgUrl: undefined,
        idCardEndType: undefined,
        idCardStart: undefined,
        idCardEnd: undefined,
        isCanji: "无",
        isTrainingPersonnel: "否",
        familyName1: "",
        familyRelation1: "",
        familyMobile1: "",
      },
      birthDayMax: birthDayMax,
      birthDayMin: birthDayMin,
      birthDay: birthDayMax,
      nation: null,
      xueliType: null,
      gender: null,
      shebaoHospital1: undefined,
      shebaoHospital2: undefined,
      shebaoHospital3: undefined,
      shebaoHospital4: undefined,
      shebaoHospital5: undefined,
      showFamily2: false,
      showFamily3: false,
      showFamily4: false,
      showFamily5: false,
    };
  },
  watch: {
    "userInfo.zhicheng": {
      handler(newName) {
        if (newName === "无") {
          this.userInfo.zhichengCate = null;
        }
      },
      immediate: true,
    },
    "userInfo.canbaoType": {
      handler(newName) {
        if (newName === "调入") {
          this.userInfo.shebaoHospital1 = undefined;
          this.userInfo.shebaoHospital2 = undefined;
          this.userInfo.shebaoHospital3 = undefined;
          this.userInfo.shebaoHospital4 = undefined;
          this.userInfo.shebaoHospital5 = undefined;
        } else if (newName === "新参统") {
          this.userInfo.shebaoHospital1 =
            this.userInfo.shebaoHospital1 || this.sourceInfo.shebaoHospital1;
          this.userInfo.shebaoHospital2 =
            this.userInfo.shebaoHospital2 || this.sourceInfo.shebaoHospital2;
          this.userInfo.shebaoHospital3 =
            this.userInfo.shebaoHospital3 || this.sourceInfo.shebaoHospital3;
          this.userInfo.shebaoHospital4 =
            this.userInfo.shebaoHospital4 || this.sourceInfo.shebaoHospital4;
          this.userInfo.shebaoHospital5 =
            this.userInfo.shebaoHospital5 || this.sourceInfo.shebaoHospital5;
        }
      },
      immediate: true,
    },
    "userInfo.idCardEndType": {
      handler(newName) {
        if (newName === "长期") {
          this.userInfo.idCardEnd = null;
        }
      },
      immediate: true,
    },
    "userInfo.emergency1": {
      handler(newName) {
        this.userInfo.familyName1 = newName;
        if (this.sourceInfo.familyName1) {
          this.sourceInfo.familyName1 = newName;
        }
      },
      immediate: true,
    },
    "userInfo.emergency1Relation": {
      handler(newName) {
        this.userInfo.familyRelation1 = newName;
        if (this.sourceInfo.familyRelation1) {
          this.sourceInfo.familyRelation1 = newName;
        }
      },
      immediate: true,
    },
    "userInfo.emergency1Mobile": {
      handler(newName) {
        this.userInfo.familyMobile1 = newName;
        if (this.sourceInfo.familyMobile1) {
          this.sourceInfo.familyMobile1 = newName;
        }
      },
      immediate: true,
    },
  },
  computed: {
    weirenClientInfo() {
      return nativeApi.getWeirenClientInfo();
    },
    minIdCardDateEnd() {
      if (this.userInfo.idCardStart) {
        const startDate = this.userInfo.idCardStart.split("-");
        if (startDate.length === 3) {
          let data = new Date();
          data.setFullYear(parseInt(startDate[0]) + 5);
          data.setMonth(parseInt(startDate[1]) - 1);
          data.setDate(startDate[2]);
          return data;
        }
      }
      return this.minIdCardDate;
    },
    maxIdCardDateEnd() {
      if (this.userInfo.idCardStart) {
        const startDate = this.userInfo.idCardStart.split("-");
        if (startDate.length === 3) {
          let data = new Date();
          data.setFullYear(parseInt(startDate[0]) + 30);
          data.setMonth(parseInt(startDate[1]) - 1);
          data.setDate(startDate[2]);
          return data;
        }
      }
      let nowDate = new Date();
      nowDate.setFullYear(nowDate.getFullYear() + 30);
      return nowDate;
    },
    isAgeGreaterThan45() {
      if (this.userInfo.idCard && this.userInfo.idCard.length > 17) {
        // 提取身份证中的出生年份
        const birthYear = parseInt(this.userInfo.idCard.substring(6, 10));
        const currentYear = new Date().getFullYear();
        const age = currentYear - birthYear;
        return age > 45;
      }
      return false;
    },
  },
  methods: {
    handleEmergencyChange() {
      // this.$nextTick(() => {
      //   this.userInfo.familyName1 = this.userInfo.emergency1
      //   if (this.sourceInfo.familyName1) {
      //     this.sourceInfo.familyName1 = this.userInfo.emergency1
      //   }
      //   this.userInfo.familyRelation1 = this.userInfo.emergency1Relation
      //   if (this.sourceInfo.familyRelation1) {
      //     this.sourceInfo.familyRelation1 = this.userInfo.emergency1Relation
      //   }
      //   this.userInfo.familyMobile1 = this.userInfo.emergency1Mobile
      //   if (this.sourceInfo.familyMobile1) {
      //     this.sourceInfo.familyMobile1 = this.userInfo.emergency1Mobile
      //   }
      // })
    },
    checkContactAddress(value) {
      return (
        value &&
        value.length > 3 &&
        (value.indexOf("北京市") > -1 ||
          value.indexOf("天津市") > -1 ||
          value.indexOf("河北省") > -1)
      );
    },
    removeFamily2() {
      this.showFamily2 = false;
      this.userInfo.familyName2 = "";
      this.sourceInfo.familyName2 = "";
      this.userInfo.familyWork2 = "";
      this.sourceInfo.familyWork2 = "";
      this.userInfo.familyRelation2 = "";
      this.sourceInfo.familyRelation2 = "";
      this.userInfo.familyMobile2 = "";
      this.sourceInfo.familyMobile2 = "";
    },
    removeFamily3() {
      this.showFamily3 = false;
      this.userInfo.familyName3 = "";
      this.sourceInfo.familyName3 = "";
      this.userInfo.familyWork3 = "";
      this.sourceInfo.familyWork3 = "";
      this.userInfo.familyRelation3 = "";
      this.sourceInfo.familyRelation3 = "";
      this.userInfo.familyMobile3 = "";
      this.sourceInfo.familyMobile3 = "";
    },
    removeFamily4() {
      this.showFamily4 = false;
      this.userInfo.familyName4 = "";
      this.sourceInfo.familyName4 = "";
      this.userInfo.familyWork4 = "";
      this.sourceInfo.familyWork4 = "";
      this.userInfo.familyRelation4 = "";
      this.sourceInfo.familyRelation4 = "";
      this.userInfo.familyMobile4 = "";
      this.sourceInfo.familyMobile4 = "";
    },
    removeFamily5() {
      this.showFamily5 = false;
      this.userInfo.familyName5 = "";
      this.sourceInfo.familyName5 = "";
      this.userInfo.familyWork5 = "";
      this.sourceInfo.familyWork5 = "";
      this.userInfo.familyRelation5 = "";
      this.sourceInfo.familyRelation5 = "";
      this.userInfo.familyMobile5 = "";
      this.sourceInfo.familyMobile5 = "";
    },
    onBankCardBlur() {
      if (
        this.userInfo.gongziBankCardNo &&
        this.userInfo.gongziBankCardNo.length != 19
      ) {
        this.$toast("工资卡号位数不正确，请提供19位的工资卡号");
      } else if (
        this.userInfo.gongziBankCardNo[6] !== "0" ||
        this.userInfo.gongziBankCardNo[7] !== "2"
      ) {
        this.$toast("请填写北京本地银行卡");
      }
    },
    handleShowBankCardInput(e) {
      if (
        this.sourceInfo.gongziBankCardNo ||
        e.target.nodeName.toLowerCase() != "input"
      ) {
        return;
      }
      this.showBankCard = true;
    },
    handleConfirmBankCard(type) {
      if (type === 1) {
        //点确定
        if (
          !this.userInfo.gongziBankCardNo ||
          this.userInfo.gongziBankCardNo.length != 19
        ) {
          this.$toast("请提供" + this.bankCardTip);
          this.userInfo.gongziBankCardNo = undefined;
          return;
        }
      } else {
        //失去焦点
        this.showBankCard = false;
        if (
          this.userInfo.gongziBankCardNo &&
          this.userInfo.gongziBankCardNo.length < 19
        ) {
          this.$toast("请提供" + this.bankCardTip);
          this.userInfo.gongziBankCardNo = undefined;
          return;
        }
      }
    },
    showHelp(msg) {
      this.$dialog.alert({
        message: msg,
      });
    },

    /**
     * 显示提示信息，提醒用户填写地址时精确到门牌号。
     * 该方法通过调用 Vue 实例的 $toast 方法来展示提示信息。
     */
    showToast() {
      this.$toast(' 填写的地址请精确到门牌号');
    },

    handlePickFile() {
      if (this.sourceInfo.certImgUrl) {
        return;
      }
      const _this = this;
      nativeApi.pickFile({
        fileMaxSize: 500,
        success: (data) => {
          _this.$nextTick(() => {
            _this.userInfo.certImgUrl = data.replace(/\\/g, "");
          });
          _this.showTip("上传成功");
        },
        cancel: () => {
          _this.showTip("已取消");
        },
        error: (rep) => {
          _this.showErrorTip(rep.msg);
        },
      });
    },
    handlePreHasWorkChange(value) {
      this.userInfo.preHasNoWork = value ? 1 : 0;
    },
    handleChangeProvice(provice) {
      this.userInfo.hukouProvinceCode = provice.value;
    },
    handleClickSave() {
      const loading = this.showLoading();
      saveDetail(this.userInfo)
        .then((rep) => {
          loading.clear();
          this.showSuccessTip(rep.msg);
          this.loadData(false);
        })
        .catch((rep) => {
          loading.clear();
        });
    },
    handleBankCardConfirm() {
      if (this.userInfo.gongziBankCardNo !== this.inputBankCard) {
        this.$toast("工资卡号确认错误，请核实");
        this.$nextTick(() => {
          this.$refs["eleInput"].focus();
        });
        this.showBankCard = true;
      } else {
        this.handleClickSubmit(true);
      }
    },
    checkSubmit() {
      this.$refs.formData
        .validate()
        .then(() => {
          console.log("验证成功");
          this.handleClickSubmit();
        })
        .catch(() => {
          console.log("验证失败");
        });
    },
    handleClickSubmit(isConfirm) {
      //提示确认工资卡号
      if (this.userInfo.gongziBankCardNo && !isConfirm) {
        //如果不同则 显示再次确认工资卡号
        if (this.userInfo.gongziBankCardNo !== this.inputBankCard) {
          this.inputBankCard = undefined;
          this.showBankCardConfirm = true;
          this.$nextTick(() => {
            this.$refs["eleConfirm"].focus();
          });
          return;
        }
      }
      if (
        this.userInfo.gongziBankCardNo &&
        this.userInfo.gongziBankCardNo.length !== 19
      ) {
        this.$toast("工资卡号位数错误，请重新后重试");
        this.$refs["eleInput"].focus();
        return;
      }
      this.userInfo.docAddress = this.userInfo.contactAddress;
      if (
        this.showFamily2 &&
        (this.userInfo.familyName2 ||
          this.userInfo.familyMobile2 ||
          this.userInfo.familyRelation2 ||
          this.userInfo.familyWork2)
      ) {
        if (
          !this.userInfo.familyName2 ||
          !this.userInfo.familyMobile2 ||
          !this.userInfo.familyRelation2 ||
          !this.userInfo.familyWork2
        ) {
          this.showHelp("请完善家庭成员2信息");
          return;
        }
      }
      if (
        this.showFamily3 &&
        (this.userInfo.familyName3 ||
          this.userInfo.familyMobile3 ||
          this.userInfo.familyRelation3 ||
          this.userInfo.familyWork3)
      ) {
        if (
          !this.userInfo.familyName3 ||
          !this.userInfo.familyMobile3 ||
          !this.userInfo.familyRelation3 ||
          !this.userInfo.familyWork3
        ) {
          this.showHelp("请完善家庭成员3信息");
          return;
        }
      }
      if (
        this.showFamily4 &&
        (this.userInfo.familyName4 ||
          this.userInfo.familyMobile4 ||
          this.userInfo.familyRelation4 ||
          this.userInfo.familyWork4)
      ) {
        if (
          !this.userInfo.familyName4 ||
          !this.userInfo.familyMobile4 ||
          !this.userInfo.familyRelation4 ||
          !this.userInfo.familyWork4
        ) {
          this.showHelp("请完善家庭成员4信息");
          return;
        }
      }
      if (
        this.showFamily5 &&
        (this.userInfo.familyName5 ||
          this.userInfo.familyMobile5 ||
          this.userInfo.familyRelation5 ||
          this.userInfo.familyWork5)
      ) {
        if (
          !this.userInfo.familyName5 ||
          !this.userInfo.familyMobile5 ||
          !this.userInfo.familyRelation5 ||
          !this.userInfo.familyWork5
        ) {
          this.showHelp("请完善家庭成员5信息");
          return;
        }
      }
      this.$dialog
        .confirm({
          title: "确认并提交",
          message: "入职信息一经提交不能修改\n请确定是否提交？",
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
        })
        .then(() => {
          const loading = this.showLoading();
          submitDetail(this.userInfo)
            .then((rep) => {
              loading.clear();
              this.showSuccessTip(rep.msg);
              this.loadData(false);
            })
            .catch((rep) => {
              loading.clear();
            });
        });
    },
    loadData(showCheckResult) {
      const loading = this.showLoading();
      getDetail({})
        .then((rep) => {
          loading.clear();
          const data = rep.data;
          const saveTempData = data.saveTempData || {};
          delete data.saveTempData;
          this.sourceInfo = JSON.parse(JSON.stringify(data));
          //判断家庭成员数量
          this.showFamily2 = this.sourceInfo.familyName2;
          this.showFamily3 = this.sourceInfo.familyName3;
          this.showFamily4 = this.sourceInfo.familyName4;
          if (!saveTempData.isCriminal) {
            saveTempData.isCriminal = "否";
          }
          if (!saveTempData.isDishonest) {
            saveTempData.isDishonest = "否";
          }
          if (!saveTempData.isDismissed) {
            saveTempData.isDismissed = "否";
          }
          if (!saveTempData.isDispute) {
            saveTempData.isDispute = "否";
          }
          if (!saveTempData.isHazardous) {
            saveTempData.isHazardous = "否";
          }
          if (!saveTempData.isInjured) {
            saveTempData.isInjured = "否";
          }
          if (!this.isAgeGreaterThan45) {
            this.userInfo.idCardEndType = "固定";
          }
          this.userInfo = Object.assign(
            {
              canbaoType: undefined,
              certImgUrl: undefined,
              idCardEndType: "固定",
              idCardStart: undefined,
              idCardEnd: undefined,
              shebaoHospital1: undefined,
              shebaoHospital2: undefined,
              shebaoHospital3: undefined,
              shebaoHospital4: undefined,
              shebaoHospital5: undefined,
              isTrainingPersonnel: "否",
              isCanji: "无",
            },
            saveTempData,
            data
          );
          if (this.userInfo.birthDay) {
            this.birthDay = toDate(this.userInfo.birthDay);
          }
          this.userInfo.preHasNoWork = this.userInfo.preHasNoWork || 0;
          this.preHasNoWork = this.userInfo.preHasNoWork === 1;
          if (!this.userInfo.canEdit) {
            this.$dialog
              .alert({
                message: "目前无需完善入职信息",
              })
              .then(() => {});
          } else if (data.auditStatus === "审核通过" && showCheckResult) {
            this.$dialog
              .alert({
                title: "温馨提示",
                message: "信息已审核通过",
              })
              .then(() => {});
          } else if (data.auditStatus === "审核未通过" && showCheckResult) {
            this.$dialog
              .alert({
                title: "审核未通过",
                message: this.userInfo.auditRemark,
              })
              .then(() => {});
          }
        })
        .catch((rep) => {
          loading.clear();
        });
    },
  },
  created() {
    this.$dialog
      .alert({
        title: "入职情况说明",
        message: notifyContent,
        allowHtml: true,
        confirmButtonText: "我确定",
      })
      .then(() => {
        this.loadData(true);
      });
  },
};
</script>
